export const calendarRoute = "/calendar";

export type CalendarOccurrenceNavigationTarget = {
  start: string;
  end: string | null;
  isAllDay: boolean;
};

export function calendarRouteForDate(
  date: string,
  eventId?: string,
  occurrence?: CalendarOccurrenceNavigationTarget,
): string {
  const parameters = new URLSearchParams({ date });
  if (eventId) parameters.set("eventId", eventId);
  if (occurrence) {
    parameters.set("occurrenceStart", occurrence.start);
    if (occurrence.end) parameters.set("occurrenceEnd", occurrence.end);
    parameters.set("occurrenceAllDay", String(occurrence.isAllDay));
  }
  return `${calendarRoute}?${parameters.toString()}`;
}
